import Layout from "components/layout";
import BusinessTranslation from "components/reusableComponents/businessTranslation/BusinessTranslation";
import SEO from "components/seo";
import React from "react";

function Index() {
  const description =
    "High quality business translation services by professional business translators. Tomedes provides the best business translation quotes. Get the best combination of low cost, high quality and fast delivery language translation services from Tomedes.";
  const title = "Professional business translation services";
  const keywords = "business translation, professional business translation, business translation quote";
  return (
    <Layout>
      <SEO title={title} description={description} keywords={keywords} slug="/business-translation.php" />
      <BusinessTranslation />
    </Layout>
  );
}

export default Index;
